import React from 'react';
import {Animated, View, ViewStyle} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import {gradient} from '/component/base/PinInput/PinInput.style';

import {useCell} from './Cell.hook';

interface CellProps {
  isWrongPin: boolean;
  id: number;
  focused: boolean;
  valueLength: number;
  styles: {
    cell: ViewStyle;
    cellFilled?: ViewStyle;
    wrongCell?: ViewStyle;
    linearGradient: ViewStyle;
  };
  isWrongStyle: boolean;
  slidesUpDownAnimations: Animated.Value[];
}

export const Cell = ({
  isWrongPin = false,
  id = 0,
  focused = false,
  valueLength = 0,
  styles,
  isWrongStyle = false,
  slidesUpDownAnimations = [],
}: CellProps) => {
  const {currentCellFilled, cellFilled, opacityAnimation, shakeAnimation} =
    useCell({
      isWrongPin,
      id,
      valueLength,
      slidesUpDownAnimation:
        slidesUpDownAnimations[id] ?? new Animated.Value(0),
      focused,
    });

  return (
    <Animated.View
      key={id}
      testID={`pin-cell-${id}`}
      style={[
        styles.cell,
        currentCellFilled ? styles.cellFilled : {},
        isWrongStyle ? styles.wrongCell : {},
        cellFilled ? styles.cellFilled : {},
        {
          opacity: opacityAnimation,
          transform: [
            {translateX: shakeAnimation},
            {translateY: slidesUpDownAnimations[id] ?? new Animated.Value(0)},
          ],
        },
      ]}>
      {cellFilled ? (
        <LinearGradient
          testID={`gradient-${id}`}
          colors={gradient}
          style={styles.linearGradient}
        />
      ) : (
        <View testID="EmptyCellView" style={styles.linearGradient} />
      )}
    </Animated.View>
  );
};
